import Vue from "vue";

export default function (_store, _router) {
    let numberOfAjaxCAllPending = 0;

    // Intercept all ajax requests
    Vue.axios.interceptors.request.use(
        function (config) {
            numberOfAjaxCAllPending++;

            // Do something before request is sent
            const center = _store.getters['globalCenter']
            if (center && center.id) {
                config.params = config.params || {};
                const skipCenter = config.params['skip_center'];
                if (!skipCenter && !(config.params['center-id'] || config.params['center_id'] || config.params['centerId'])) {
                    config.params['centerId'] = center.id;
                    config.params['center-id'] = center.id;
                    config.params['center_id'] = center.id;
                }

                if (!skipCenter && (config.method === 'post' || config.method === 'put') && config.data) {
                    if (!(config.data['center-id'] || config.data['center_id'] || config.data['centerId'])) {
                        config.data['center-id'] = center.id;
                        config.data['center_id'] = center.id;
                        config.data['centerId'] = center.id;
                    }
                }
            }
            _store.dispatch('appLoading');
            return config;
        },
        function (error) {
            numberOfAjaxCAllPending--;

            if (numberOfAjaxCAllPending <= 0) {
                _store.dispatch('stopAppLoading');
            }

            _store.commit("ADD_MESSAGE", error);
            return Promise.reject(error);
        }
    );

    // Intercept all ajax responses
    Vue.axios.interceptors.response.use(
        function (response) {
            numberOfAjaxCAllPending--;

            if (numberOfAjaxCAllPending <= 0) {
                _store.dispatch('stopAppLoading');
            }
            return response;
        },
        function (err) {
            numberOfAjaxCAllPending--;

            if (numberOfAjaxCAllPending <= 0) {
                _store.dispatch('stopAppLoading');
            }

            if (!err.response) {
                // Network error or API endpoint is offline
                const message = 'The system is currently unavailable. Please check your internet connection or try again later.';
                _store.dispatch('addErrorMessage', message);
            }
            else if (err.response && err.response.status === 500) {
                const message = 'Server error, please try again later';
                _store.dispatch('addErrorMessage', message);
            }
            else if (err.response && err.response.status === 401) {
                _store.dispatch("processLogout");
                const path = '/login';
                if (_router.currentRoute.path !== path) _router.push(path);
            }

            return Promise.reject(err.response);  // Reject with the err itself, not just err.response
        }
    );

}
